import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { CircleButtonModule } from '../circle-button/circle-button.component';

@Component({
  selector: 'lp2-chip',
  template: `
    <div class="chip">
      <div class="label">{{ label }}</div>
      <i class="fa fa-times" *ngIf="showCloseButton" (click)="onCloseClick()"></i>
    </div>
  `,
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  @Input() label: string;
  @Input() showCloseButton: boolean;
  @Output() closeClick = new EventEmitter();

  onCloseClick() {
    this.closeClick.emit();
  }
}

@NgModule({
  imports: [CommonModule, CircleButtonModule],
  declarations: [ChipComponent],
  exports: [ChipComponent],
})
export class ChipModule {}



// WEBPACK FOOTER //
// ./ts/app/components/chip/chip.component.ts